import React, { useEffect, useState, useRef } from "react";
import {
  InputGroup,
  FormControl,
  Button,
  Dropdown,
  Form,
} from "react-bootstrap";
import * as XLSX from "xlsx";
import { useLocation, useNavigate } from "react-router-dom";
import { Toast, Modal } from "bootstrap";
import {
  getLeads,
  searchLeads,
  lead_insert,
  getLeadConfig,
  getUsers,
  importLeads,
} from "../../../api/lead";
import LeadTable from "../leads/leadTable";
import { saveAs } from "file-saver";
import {
  LEAD_STATUS_MAP,
  PRIORITY_MAP,
  LEAD_STATUS_BG,
  LEAD_SOURCE_MAP,
} from "../../../constants";
import CalendarFilterDropdown from "../../../components/CalendarFilter";

const LOCAL_STORAGE_KEYS = {
  priorityFilter: "leadTable_priorityFilter",
  statusFilter: "leadTable_statusFilter",
  sourceFilter: "leadTable_sourceFilter",
  followupFilter: "leadTable_followupFilter",
  assignedToFilter: "leadTable_assignedToFilter",
  classFilter: "leadTable_classFilter",
  dateSortOrder: "leadTable_dateSortOrder",
};

const LeadList = () => {
  const location = useLocation();
  const userType = localStorage.getItem("type");
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [loadingData, setLoadingData] = useState(true);
  const [leads, setLeads] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [filtered_leads, setFilteredLeads] = useState([]);
  const [userList, setUserList] = useState([]);
  const toastRef = useRef(null);
  const modalRef = useRef(null);
  const [show, setShow] = useState(false);
  const [configuration, setConfiguration] = useState();
  const [selectedDate, setSelectedDate] = useState(null);
  const [sourcefilter, setSourceFilter] = useState([]);
  const [priorityFilter, setPriorityFilter] = useState([]);
  const [statusFilter, setStatusFilter] = useState([]);
  const [followupFilter, setFollowupFilter] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [filterDate, setFilterDate] = useState([]);

  const [currentFilterList, setCurrentFilterList] = useState([]);

  const initialFormData = {
    name: "",
    email: "",
    source: "",
    lead_type: "",
    parent_name: "",
    studentClass: "",
    school: "",
    course: "",
    phone: "",
    city: "",
    country: "",
    message: "",
    assignToSelf: false,
  };
  const [formData, setFormData] = useState(initialFormData);

  const fetchData = async (
    priorityFilter,
    statusFilter,
    sourcefilter,
    followupFilter,
    selectedUsers,
    filterDate
  ) => {
    setLoadingData(true);
    try {
      let types =
        "lead_types,lead_sources,city,country,lead_status,priority,followup_type";

      let params = new URLSearchParams();
      if (priorityFilter.length)
        params.append("priority", priorityFilter.map(Number).join(","));
      if (statusFilter.length)
        params.append("status_id", statusFilter.join(","));
      if (sourcefilter.length) params.append("source", sourcefilter.join(","));
      if (followupFilter.length)
        params.append("followUpType", followupFilter.join(","));
      if (selectedUsers.length)
        params.append("assigned_to", selectedUsers.join(","));
      if (Array.isArray(filterDate) && filterDate.length >= 1) {
        const start = new Date(filterDate[0]);
        const end =
          filterDate.length === 2 ? new Date(filterDate[1]) : new Date(); // today's date

        const startDate = start;
        const endDate = end;

        params.append("start_date", startDate);
        params.append("end_date", endDate);
      }

      const isAdmin = userType === "Admin" || userType === "admin";
      const [leadsData, configData, usersData] = await Promise.all([
        getLeads(`?${params.toString()}`),
        getLeadConfig(types),
        isAdmin ? getUsers({ user_type: "Agent" }) : Promise.resolve(null),
      ]);

      // If any of the requests returned a 403, redirect
      const isForbidden = [leadsData, configData, usersData].some((data) =>
        [403, 404, 500].includes(data?.status)
      );

      if (isForbidden) {
        navigate("/internal/lead/login"); // or window.location.href = "/forbidden";
        return;
      }
      // console.log(configData)
      if (
        leadsData?.status &&
        configData?.status &&
        (!isAdmin || usersData?.status)
      ) {
        setLeads(leadsData.data);
        setFilteredLeads(leadsData.data);
        setConfiguration(configData.data);
      
        if (isAdmin && usersData?.data) {
          setUserList(usersData.data);
      
          const userIds = usersData.data.map((user) => user.id);
          // setSelectedUsers(userIds);
        }
      
        const statusIds = configData.data.lead_status.map(
          (status) => status.id
        );
        // setSelectedStatuses(statusIds);
      
      } else {
        console.warn("One of the required responses had a false status");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    // Object.values(LOCAL_STORAGE_KEYS).forEach((key) => {
    //   console.log(localStorage.getItem(key))
    // });
    fetchData(
      priorityFilter,
      statusFilter,
      sourcefilter,
      followupFilter,
      selectedUsers,
      filterDate
    );
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleClose = () => setShow(false);

  const handleRemove = (itemToRemove) => {
    setCurrentFilterList((prevList) =>
      prevList.filter((item) => item !== itemToRemove)
    );
  };

  const handleSearchClick = async (type) => {
    setLoadingData(true);
    let returnData;
    if (searchValue == "") {
      returnData = await getLeads();

      setLeads(returnData.data);
      setFilteredLeads(returnData.data);
      setLoadingData(false);
    } else {
      let data = {
        query: searchValue,
        type: type,
      };

      returnData = await searchLeads(data);
      setLeads(returnData.data);
      setFilteredLeads(returnData.data);
      setLoadingData(false);
    }
  };

  const handleFilterSearch = () => {
    Object.values(LOCAL_STORAGE_KEYS).forEach((key) => {
      localStorage.removeItem(key);
    });

    fetchData(
      priorityFilter,
      statusFilter,
      sourcefilter,
      followupFilter,
      selectedUsers,
      filterDate
    );
  };

  const handleResetFilters = () => {
    setSourceFilter([]);
    setStatusFilter([]);
    setPriorityFilter([]);
    setFollowupFilter([]);
    setSelectedUsers([]);

    setCurrentFilterList([]);
    fetchData();
  };

  const handleSelect = (value, type, string) => {
    const filterStateMap = {
      priority: [priorityFilter, setPriorityFilter],
      status: [statusFilter, setStatusFilter],
      source: [sourcefilter, setSourceFilter],
      followup: [followupFilter, setFollowupFilter],
      assignedTo: [selectedUsers, setSelectedUsers],
      date: [filterDate, setFilterDate],
    };

    const [currentFilter, setFilter] = filterStateMap[type] || [];

    if (!setFilter) {
      console.warn(`Unknown filter type: ${type}`);
      return;
    }

    // Parse value to number if not date
    const parsedValue = type !== "date" ? Number(value) : value;

    // Check if the value already exists in any filter
    let isAlreadySelected = false;

    Object.entries(filterStateMap).forEach(
      ([filterKey, [filterValues, setFilterValues]]) => {
        if (filterValues.includes(parsedValue)) {
          isAlreadySelected = true;
          // Remove it from the existing filter
          setFilterValues(filterValues.filter((item) => item !== parsedValue));
        }
      }
    );

    // Update the visual label list accordingly
    setCurrentFilterList((prevList) => {
      const alreadyInList = prevList.includes(string);
      return alreadyInList
        ? prevList.filter((item) => item !== string) // Remove if already selected
        : [...prevList, string]; // Add if not
    });

    // If it wasn't selected before, add it to the current filter
    if (!isAlreadySelected) {
      setFilter([...currentFilter, parsedValue]);
    }
  };

  const handleUserSelect = (user) => {
    let updatedUsers;

    if (selectedStatuses.includes(user)) {
      updatedUsers = selectedStatuses.filter((s) => s !== user);
    } else {
      updatedUsers = [...selectedStatuses, user];
    }

    setSelectedStatuses(updatedUsers);
    const filterLeads = leads.filter((lead) =>
      updatedUsers.includes(lead.assigned_to)
    );
    setFilteredLeads(filterLeads);
  };

  const handleNavigate = (url) => {
    navigate("/home/add-lead");
  };

  const handleImport = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];
    const fileType = file.type;

    if (!validTypes.includes(fileType)) {
      alert("Please upload a valid .xlsx or .csv file.");
      return;
    }

    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      const cleanedData = jsonData
        .filter(
          (row) =>
            row.stage ||
            row.name ||
            row.email ||
            row.phone ||
            row.source ||
            row.parent_name ||
            row.course ||
            row.city ||
            row.country ||
            row.remarks
        )
        .map((row, index) => {
          return {
            stage: row.stage?.toString().trim() || "",
            name: row.name?.toString().trim() || "",
            email: row.email?.toString().trim() || "",
            phone: row.phone ? row.phone.toString().trim() : "",
            // source: row.source?.toString().trim() || "",
            parent_name: row.parent_name?.toString().trim() || "",
            course: row.course?.toString().trim() || "",
            city: row.city?.toString().trim() || "0",
            country: row.country?.toString().trim() || "0",
            remarks: row.remarks?.toString().trim() || "",
            studentClass: row.studentClass?.toString().trim() || "",
            source: Number.isInteger(
              parseInt((row.source_id ?? "").toString().trim(), 10)
            )
              ? parseInt((row.source_id ?? "").toString().trim(), 10)
              : 0,
            lead_type: parseInt(row.lead_type?.trim()) || 1,
            priority: Number.isInteger(
              parseInt((row.priority ?? "").toString().trim(), 10)
            )
              ? parseInt((row.priority ?? "").toString().trim(), 10)
              : 0,
            school: row.school?.toString().trim() || "",
            status_id: Number.isInteger(
              parseInt((row.status_id ?? "").toString().trim(), 10)
            )
              ? parseInt((row.status_id ?? "").toString().trim(), 10)
              : 0,
            followUpType: Number.isInteger(
              parseInt((row.followUpType ?? "").toString().trim(), 10)
            )
              ? parseInt((row.followUpType ?? "").toString().trim(), 10)
              : 0,
            assigned_to: Number.isInteger(
              parseInt((row.assigned_to ?? "").toString().trim(), 10)
            )
              ? parseInt((row.assigned_to ?? "").toString().trim(), 10)
              : null,
            history: {
              remark_1: row.remark_1 || "",
              remark_2: row.remark_2 || "",
              remark_3: row.remark_3 || "",
              remark_4: row.remark_4 || "",
              remark_5: row.remark_5 || "",
              remark_6: row.remark_6 || "",
              remark_7: row.remark_7 || "",
              remark_8: row.remark_8 || "",
              remark_9: row.remark_9 || "",
              remark_10: row.remark_10 || "",
            },
            rowIndex: index + 2,
          };
        });

      const invalidRows = cleanedData.filter((row) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isEmailValid = row.email === "" || emailRegex.test(row.email);
        const isPhoneValid =
          row.phone === "" || /^[\d+()-\s]+$/.test(row.phone);
        return !isEmailValid || !isPhoneValid;
      });

      if (invalidRows.length > 0) {
        const message = invalidRows
          .map((r) => `Row ${r.rowIndex}: Invalid email or phone`)
          .join("\n");
        alert("Data contains errors:\n" + message);
        return;
      }

      try {
        const response = await importLeads(cleanedData);
        if (response.status === true) {
          alert("Data imported successfully!");
          window.location.reload();
        } else {
          alert("Import failed. Server returned an error.");
        }
      } catch (error) {
        // console.error("Error importing data:", error);
        alert("Failed to import data.");
      }
    };

    reader.readAsArrayBuffer(file);

    fetchData();
  };

  const handleExport = () => {
    const exportData = leads.map((lead) => ({
      Lead_ID: lead?.lead_id,
      Stage: lead?.stage || "",
      Name: lead?.name || "",
      Email: lead?.email || "",
      Phone: lead?.phone || "",
      Priority: lead.priority
        ? configuration?.priority?.find((p) => p.id === Number(lead.priority))
            ?.name || "Cold"
        : "Cold",
      Status: LEAD_STATUS_MAP[lead.status_id] || "",
      Source: lead.source
        ? configuration?.lead_sources?.find(
            (src) => src.id === Number(lead.source)
          )?.name || "NA"
        : "NA",
      Updated_At: lead?.updated_at?.$date
        ? new Date(lead.updated_at.$date).toLocaleString()
        : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(file, "leads_export.xlsx");
  };

  return loadingData == true ? (
    <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <div className="lead-home-container">
      {/* Filter Section */}
      <div className="home-filter-container mt-5">
        <div className="row">
          {/* Search Input */}
          <div className="col">
            <InputGroup className="mb-3">
              <FormControl
                placeholder="Lead ID / Phone Number"
                aria-label="Lead ID / Phone Number"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchClick("searchBar");
                  }
                }}
              />
              <Button
                className="primary-button"
                variant="primary"
                id="lead-search-button"
                onClick={() => handleSearchClick("searchBar")}
              >
                Search
              </Button>
            </InputGroup>
          </div>

          {/* Checkbox Dropdown */}
          {/* <div className="col">
            <Dropdown>
              <Dropdown.Toggle
                className="primary-button"
                variant="primary"
                id="dropdownMenuButton"
              >
                Lead Status
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ padding: "10px" }}>
                {
                  configuration.lead_status.map((status, index) => (
                    <Form.Check
                      type="checkbox"
                      id="Checkme1"
                      label={status.name}
                      
                      onClick={() => handleSelect(status.id)}
                    />
                  ))
                }
              </Dropdown.Menu>
            </Dropdown>
          </div> */}

          <div className="col"></div>
          <div className="col"></div>

          {/* Buttons */}

          <div className="col"></div>
        </div>
      </div>
      <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 11 }}>
        <div
          ref={toastRef}
          className="toast align-items-center text-bg-success border-0"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="d-flex">
            <div className="toast-body">Lead Created Successfully !</div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              data-bs-dismiss="toast"
              aria-label="Close"
            ></button>
          </div>
        </div>
      </div>
      <div className="mb-3 d-flex align-items-center gap-3">
        {/* <h3>Filters</h3> */}
        {userType === "admin" ||
          (userType === "Admin" && (
            <>
              <Dropdown>
                <Dropdown.Toggle
                  className="btn-transfer-to"
                  variant="primary"
                  id="dropdownMenuButton"
                >
                  Source
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ padding: "10px" }}>
                  {configuration.lead_sources.map((status, index) => (
                    <Form.Check
                      key={index}
                      type="checkbox"
                      id="Checkme1"
                      label={status.name}
                      onClick={() =>
                        handleSelect(status.id, "source", status.name)
                      }
                    />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown>
                <Dropdown.Toggle
                  className="btn-transfer-to"
                  variant="primary"
                  id="dropdownMenuButton"
                >
                  Priority
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ padding: "10px" }}>
                  {configuration.priority.map((priority, index) => (
                    <Form.Check
                      key={index}
                      type="checkbox"
                      id="Checkme1"
                      label={priority.name}
                      onClick={() =>
                        handleSelect(priority.id, "priority", priority.name)
                      }
                    />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown>
                <Dropdown.Toggle
                  className="btn-transfer-to"
                  variant="primary"
                  id="dropdownMenuButton"
                >
                  Status
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ padding: "10px" }}>
                  {configuration.lead_status.map((status, index) => (
                    <Form.Check
                      key={index}
                      type="checkbox"
                      id="Checkme1"
                      label={status.name}
                      onClick={() =>
                        handleSelect(status.id, "status", status.name)
                      }
                    />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown>
                <Dropdown.Toggle
                  className="btn-transfer-to"
                  variant="primary"
                  id="dropdownMenuButton"
                >
                  Follow Up Type
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ padding: "10px" }}>
                  {configuration.followup_type.map((followup, index) => (
                    <Form.Check
                      key={index}
                      type="checkbox"
                      id="Checkme1"
                      label={followup.name}
                      onClick={() =>
                        handleSelect(followup.id, "followup", followup.name)
                      }
                    />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </>
          ))}

        {userType === "admin" ||
          (userType === "Admin" && (
            <Dropdown>
              <Dropdown.Toggle
                className="btn-transfer-to"
                variant="primary"
                id="dropdownMenuButton"
              >
                Agent List
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ padding: "10px" }}>
                <Form.Check
                  type="checkbox"
                  id="Checkme1"
                  label="Unassigned"
                  onClick={() => handleSelect(0, "assignedTo", "Unassigned")}
                />
                {userList.map((agent, index) => (
                  <Form.Check
                    key={index}
                    type="checkbox"
                    id="Checkme1"
                    label={agent.name}
                    onClick={() =>
                      handleSelect(agent.id, "assignedTo", agent.name)
                    }
                  />
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ))}

        {/* <CalendarFilterDropdown
            selectedDate={selectedDate}
            onDateChange={(date) => {
              setSelectedDate(date);
              handleSelect(date, "date");
            }}
          /> */}

        {userType === "admin" ||
          (userType === "Admin" && (
            <>
              <Button
                variant="primary primary-button"
                onClick={() => handleFilterSearch()}
              >
                Filter Leads
              </Button>
              <Button
                type="button"
                className="btn btn-danger"
                onClick={() => handleResetFilters()}
              >
                Reset Main Filters
              </Button>
            </>
          ))}
        <Button
          variant="primary primary-button"
          className="mx-2"
          onClick={() => {
            handleNavigate("/home/add-list");
          }}
        >
          Add New Lead
        </Button>

        {userType === "admin" ||
          (userType === "Admin" && (
            <>
              <Button
                variant="primary primary-button"
                className="mx-2"
                onClick={handleImport}
              >
                Import Data
              </Button>
              <input
                type="file"
                ref={fileInputRef}
                accept=".xlsx, .csv"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </>
          ))}

        {/* <Button type="button" className="btn btn-danger" >Reset Filter</Button> */}
      </div>
      <div className="chip-container">
        {currentFilterList.map((item, index) => (
          <span key={index} className="chip">
            {item}
            <button className="chip-close" onClick={() => handleRemove(item)}>
              &times;
            </button>
          </span>
        ))}
      </div>
      <hr></hr>
      <div className="home-list-table mt-2">
        <LeadTable
          leads={filtered_leads}
          users={userList}
          configuration={configuration}
        />
      </div>
    </div>
  );
};

export default LeadList;
